import React from 'react';
import { styled } from '../../assets/theme';
import { ActiveRotations, CompleteRotationalModelTrades } from '../WatchBox/components';

export const Rotation: React.FunctionComponent<{id: number}> = ({ id }) => {
  return (
    <div>
      <SectionHeader>Active Rotations</SectionHeader>
      <ActiveRotations id={id} />
      <SectionHeader>Completed Rotational Model Trades</SectionHeader>
      <CompleteRotationalModelTrades id={id} />
    </div>
  );
};

const SectionHeader = styled.div`
  margin-bottom: 1em;
  margin-top: 1em;
`;